<template>
    <ul class="pagination pagination-rounded justify-content-center mt-4">
        <li class="page-item" :class="{'disabled': paginationDetails.current_page == 1 }" title="First Page">
            <Link :href="paginationDetails.path + 1" class="page-link">
                <i class="mdi mdi-chevron-double-left"></i>
            </Link>
        </li>
        <li class="page-item" :class="{'disabled': paginationDetails.prev_page_url == null }">
            <Link :href="paginationDetails.prev_page_url" class="page-link">
                <i class="mdi mdi-chevron-left"></i>
            </Link>
        </li>
        <li v-if="paginationDetails.current_page > 3" class="page-item" :class="{'disabled': paginationDetails.current_page == 1 }">
            <Link :href="paginationDetails.path + 1" class="page-link">
                1
            </Link>
        </li>
        <li v-if="paginationDetails.current_page > 4" class="page-item disabled">
            <Link href="Javascript:void(0)" class="page-link">
                ...
            </Link>
        </li>
        <template v-for="index in paginationDetails.last_page">
            <li :key="index" v-if="index >= paginationDetails.current_page - 2 && index <= paginationDetails.current_page + 2" class="page-item" :class="{'active': index == paginationDetails.current_page}">
                <Link :href="paginationDetails.path + index" class="page-link">
                    {{index}}
                </Link>
            </li>
        </template>
        <li v-if="paginationDetails.current_page < paginationDetails.last_page - 3" class="page-item disabled">
            <Link href="Javascript:void(0)" class="page-link">
                ...
            </Link>
        </li>
        <li v-if="paginationDetails.current_page < paginationDetails.last_page - 2" class="page-item"  :class="{'active': paginationDetails.current_page === paginationDetails.last_page}">
            <Link :href="paginationDetails.path + paginationDetails.last_page" class="page-link">
                {{paginationDetails.last_page}}
            </Link>
        </li>
        <li class="page-item" :class="{'disabled': paginationDetails.next_page_url == null }">
            <Link :href="paginationDetails.next_page_url" class="page-link">
                <i class="mdi mdi-chevron-right"></i>
            </Link>
        </li>
        <li class="page-item" :class="{'disabled': paginationDetails.current_page == paginationDetails.last_page }" title="Last Page">
            <Link :href="paginationDetails.path + paginationDetails.last_page" class="page-link">
                <i class="mdi mdi-chevron-double-right"></i>
            </Link>
        </li>
    </ul>
</template>
<script>
    export default {
        props: {
            paginationDetails: Object
        },
    }
</script>